import { graphql } from '~/graphql';
import { useGraphqlQuery } from '~/hooks/useGraphqlQuery';

export const usePlatformProducts = () => {
  const platformProductsQuery = graphql(`
    query platformProducts {
      platformProducts {
        id
        name
      }
    }
  `);

  return useGraphqlQuery(platformProductsQuery, ['platformProducts']);
};

export const useGetPlatformProductById = (platformProductId: string) => {
  const platformProductQuery = graphql(`
    query platformProductById($platformProductId: ID!) {
      platformProduct(id: $platformProductId) {
        actualLengthInches
        actualThicknessInches
        actualWidthInches
        code
        constructionCode
        finishCode
        harmonizedCode
        id
        isNominal
        lengths {
          actualLengthInches
          nominalLengthInches
          displayValue
          id
        }
        materialCode
        name
        nominalThicknessInches
        nominalWidthInches
        properties {
          construction {
            code
            name
          }
          dryness {
            code
            name
          }
          grade {
            code
            name
          }
          species {
            code
            name
          }
          surfacing {
            code
            name
          }
          treatment {
            code
            name
          }
        }
        piecesPerBundle {
          value
          unit
        }
        standardUnitsCode
        unitsPerContainer {
          value
          unit
        }
        unitsPerRailCar {
          value
          unit
        }
        unitsPerTruckload {
          value
          unit
        }
      }
    }
  `);

  return useGraphqlQuery(
    platformProductQuery,
    ['platformProduct', platformProductId],
    { platformProductId: platformProductId }
  );
};
